import { TagsProps, TagItemProps } from './Tags.types'
import { TagsWrapper } from './Tags.styles'
import { isString } from '../../../utils'
import TagItem from './TagItem'

const Tags = ({
  className = '',
  items = [],
  size = 'small',
  color = 'default',
  variant = 'filled',
  radius,
  vertical = false,
  gap,
  direction,
  labelProps,
  subLabelProps,
  longSize = 11,
  styles,
  ...props
}: TagsProps) => {
  const globalItemProps: TagItemProps = {
    label: '',
    size,
    color,
    variant,
    radius,
    vertical,
    gap,
    longSize
  }

  return (
    <TagsWrapper
      className={`Tags ${className}`}
      sx={styles}
      size={size}
      variant={variant}
      vertical={direction === 'vertical'}
      {...props}>
      {items.map((tag) => {
        const itemProps = {
          ...globalItemProps,
          ...(isString(tag)
            ? { label: { value: tag, ...labelProps } }
            : {
                ...tag,
                label: isString(tag.label)
                  ? { value: tag.label, ...labelProps }
                  : tag.label,
                subLabel: isString(tag.subLabel)
                  ? { value: tag.subLabel, ...subLabelProps }
                  : tag.subLabel
              })
        }

        return <TagItem {...itemProps} key={itemProps.label.value} />
      })}
    </TagsWrapper>
  )
}

export default Tags
